import { useQuery } from "@tanstack/react-query";

import { getActiveUsers } from "@/api/active-users";
import { diagnosticKeys } from "@/hooks/useDiagnostic";

/**
 * Os usuários ativos do Diagnóstico, para o detalhe aberto pela caixa do Ato 1
 * (#1478). A chave fica debaixo do prefixo do snapshot, como as outras listas do
 * Diagnóstico: o que invalida o snapshot relê esta lista junto.
 */
export function useActiveUsers(projectId: string | undefined) {
  return useQuery({
    queryKey: [...diagnosticKeys.snapshot(projectId ?? ""), "active-users"] as const,
    queryFn: () => getActiveUsers(projectId!),
    enabled: !!projectId,
    staleTime: 30_000,
  });
}
